<div
    class="tw-hidden lg:tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-[12vw] md:tw-gap-[5vw] 2xl:tw-gap-[2vw] tw-pt-[5rem] tw-pb-[2rem] lg:tw-pb-[5rem] tw-h-[513.71px]"
>
    <div
        class="tw-w-full tw-max-w-[100%] sm:tw-max-w-auto lg:tw-max-w-[100%] tw-flex tw-flex-col lg:tw-px-[4vw]"
    >
        <div
            class="tw-w-full tw-text-center lg:tw-text-left tw-text-[32px] lg:tw-text-[30px] tw-text-[#003A70] tw-font-bold lg:tw-font-semibold"
        >
            {{ "CGC_DEV_PROG_PAGE.GALLERY" | translate }}
        </div>
        <div
            class="tw-pl-[5vw] sm:tw-pl-[5vw] lg:tw-pl-[0vw] tw-pr-[5vw] sm:tw-pr-[5vw] lg:tw-pr-[0vw] tw-pt-[4vw] sm:tw-pt-[4vw] lg:tw-pt-[2vw] tw-w-[100%] lg:tw-w-full tw-text-center sm:tw-text-center lg:tw-text-left tw-text-[#7E7E7E]"
        >
            <mat-tab-group>
                <mat-tab
                    *ngIf="imageObjectFA.length"
                    label="{{ 'LNDP_CALENDAR.FINANCIAL_ADVISORY' | translate }}"
                >
                    <div
                        *ngIf="imageObjectFA.length <= minLength"
                        class="tw-flex tw-flex-row tw-gap-10"
                    >
                        <div
                            *ngFor="let item of imageObjectFA"
                            [ngClass]="imageObjectFA.length <= minLength? 'tw-my-auto tw-mx-0 tw-ml-[5%]': 'tw-m-auto'"
                        >
                            <p-image  
                                src="{{item.image}}"
                                previewImageSrc="{{item.thumbImage}}"
                                alt="{{item.alt}}" 
                                width="205px"
                                [preview]="true"
                            />
                        </div>
                    </div>
                    <div
                        *ngIf="imageObjectFA.length > minLength"
                        class="tw-h-auto tw-text-center tw-m-0 tw-p-0"
                    >
                        <ng-image-slider
                            slideImage="1"
                            [infinite]="true"
                            [autoSlide]="{interval: 1, stopOnHover: true}"
                            [images]="imageObjectFA"
                            [imageSize]="{width: '205px', height: '205px', space:60}"
                            animationSpeed="0.6"
                            #nav
                        ></ng-image-slider>
                    </div>
                </mat-tab>
                <mat-tab
                    *ngIf="imageObjectAW.length"
                    label="{{ 'LNDP_CALENDAR.ADVISORY_WORKSHOP' | translate }}"
                >
                    <div
                        *ngIf="imageObjectAW.length <= minLength"
                        class="tw-flex tw-flex-row tw-gap-10"
                    >
                        <div
                            *ngFor="let item of imageObjectAW"
                            [ngClass]="imageObjectAW.length <= minLength? 'tw-my-auto tw-mx-0 tw-ml-[5%]': 'tw-m-auto'"
                        >
                            <p-image  
                                src="{{item.image}}"
                                previewImageSrc="{{item.thumbImage}}"
                                alt="{{item.alt}}" 
                                width="205px"
                                [preview]="true"
                            />
                        </div>
                    </div>
                    <div
                        *ngIf="imageObjectAW.length > minLength"
                        class="tw-h-auto tw-text-center tw-m-0 tw-p-0"
                    >
                        <ng-image-slider
                            slideImage="1"
                            [infinite]="true"
                            [autoSlide]="{interval: 1, stopOnHover: true}"
                            [images]="imageObjectAW"
                            [imageSize]="{width: '205px', height: '205px', space:60}"
                            animationSpeed="0.6"
                            #nav
                        ></ng-image-slider>
                    </div>
                </mat-tab>
                <mat-tab
                    *ngIf="imageObjectANM.length"
                    label="{{ 'LNDP_CALENDAR.ACCESS_NEW_MARKETS' | translate }}"
                >
                    <div
                        *ngIf="imageObjectANM.length <= minLength"
                        class="tw-flex tw-flex-row tw-gap-10"
                    >
                        <div
                            *ngFor="let item of imageObjectANM"
                            [ngClass]="imageObjectANM.length <= minLength? 'tw-my-auto tw-mx-0 tw-ml-[5%]': 'tw-m-auto'"
                        >
                            <p-image  
                                src="{{item.image}}"
                                previewImageSrc="{{item.thumbImage}}"
                                alt="{{item.alt}}" 
                                width="205px"
                                [preview]="true"
                            />
                        </div>
                    </div>
                    <div
                        *ngIf="imageObjectANM.length > minLength"
                        class="tw-h-auto tw-text-center tw-m-0 tw-p-0"
                    >
                        <ng-image-slider
                            slideImage="1"
                            [infinite]="true"
                            [autoSlide]="{interval: 1, stopOnHover: true}"
                            [images]="imageObjectANM"
                            [imageSize]="{width: '205px', height: '205px', space:60}"
                            animationSpeed="0.6"
                            #nav
                        ></ng-image-slider>
                    </div>
                </mat-tab>
                <mat-tab
                    *ngIf="imageObjectNS.length"
                    label="{{ 'LNDP_CALENDAR.NETWORKING_SESSION' | translate }}"
                >
                    <div
                        *ngIf="imageObjectNS.length <= minLength"
                        class="tw-flex tw-flex-row tw-gap-10"
                    >
                        <div
                            *ngFor="let item of imageObjectNS"
                            [ngClass]="imageObjectNS.length <= minLength? 'tw-my-auto tw-mx-0 tw-ml-[5%]': 'tw-m-auto'"
                        >
                            <p-image  
                                src="{{item.image}}"
                                previewImageSrc="{{item.thumbImage}}"
                                alt="{{item.alt}}" 
                                width="205px"
                                [preview]="true"
                            />
                        </div>
                    </div>
                    <div
                        *ngIf="imageObjectNS.length > minLength"
                        class="tw-h-auto tw-text-center tw-m-0 tw-p-0"
                    >
                        <ng-image-slider
                            slideImage="1"
                            [infinite]="true"
                            [autoSlide]="{interval: 1, stopOnHover: true}"
                            [images]="imageObjectNS"
                            [imageSize]="{width: '205px', height: '205px', space:60}"
                            animationSpeed="0.6"
                            #nav
                        ></ng-image-slider>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>